<div
  class="layout-wrapper layout-2"
  [ngClass]="{ 'layout-loading': !initialized }"
>
  <div class="layout-inner">
    <div class="layout-container">
      <div class="layout-content">
        <div
          class="bgLogin container-fluid router-transitions flex-grow-1 px-0"
        >
          <router-outlet></router-outlet>
          <div class="row">
            <div class="col-12 col-md-12 col-lg-9 col-xl-7">
              <div class="disclaimer">
                <p>
                  De vzw FETRAPI geeft geen garantie voor de actualiteit,
                  juistheid, correctheid, volledigheid en kwaliteit van de
                  informatie die door haar leden op het portaal geüpload wordt.
                  De leden van de vzw FETRAPI behouden de volledige
                  verantwoordelijkheid over de voormelde informatie en zien er
                  te allen tijde op toe dat deze informatie zoals geüpload op
                  het portaal correct en up-to-date is en blijft.
                  <br />
                  <br />
                  Aansprakelijkheid, voor welke schade dan ook, daaronder
                  begrepen schade die voortkomt uit winstverlies,
                  gegevensverlies of onderbreking van werkzaamheden, die
                  betrekking hebben op het gebruik van de aangeboden informatie
                  respectievelijk door het gebruik van foutieve of onvolledige
                  informatie, wijst de vzw FETRAPI nadrukkelijk van de hand,
                  voor zover er geen sprake is van aantoonbare opzettelijke of
                  grote nalatigheid in hoofde van de vzw FETRAPI.
                  <br />
                  <br />
                  L'asbl FETRAPI ne garantit pas que les informations
                  téléchargées par ses membres sur le portail sont à jour, ni
                  leur exactitude, leur exhaustivité ou leur qualité. Les
                  membres de l'asbl FETRAPI demeurent entièrement responsables
                  des informations susmentionnées et s'assurent à tout moment
                  que les informations téléchargées sur le portail sont
                  correctes et à jour.
                  <br />
                  <br />
                  L'asbl FETRAPI décline expressément toute responsabilité pour
                  tout dommage, de quelque nature que ce soit, y compris le
                  manque à gagner, la perte de données ou l'interruption des
                  activités, lié à l'utilisation des informations fournies ou
                  résultant de l'utilisation d'informations erronées ou
                  incomplètes, sauf à démontrer dans le chef de l’asbl FETRAPI
                  une négligence intentionnelle ou grave.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="isAcceptance"
          class="alert alert-warning"
          style="margin-bottom: 0px"
          role="alert"
        >
          As of May 13th, 2024, multi-factor authentication (MFA) has been
          enabled on the Fetrapi acceptance portal. Please use the Microsoft
          authenticator or SMS to authenticate.
        </div>
        <div
          *ngIf="!isAcceptance"
          class="alert alert-warning"
          style="margin-bottom: 0px"
          role="alert"
        >
          As of June 24th, 2024, multi-factor authentication (MFA) will be
          enabled on the Fetrapi production portal. Please use the Microsoft
          authenticator or SMS to authenticate.
        </div>


        <!-- <nav class="footer" [ngClass]="currentBg()">
          <div class="container-fluid container-p-x pb-3">
            <a
              href="https://www.merkator.com/contact"
              class="footer-link pt-3"
              target="_blank">
              Contact Helpdesk
            </a>
            <a href="http://www.Fetrapi.be" class="footer-link pt-3 ms-4">Fetrapi home page</a>
            <label
              class="footer-link pt-3 ms-4 float-end text-danger"
              *ngIf="isAcceptance"
            >
              THIS IS THE FETRAPI ACCEPTANCE PORTAL. DO NOT USE FOR PRODUCTION DATA
            </label>
          </div>
        </nav> -->

        <app-layout-footer [isLogin]="true"></app-layout-footer>

      </div>
    </div>
  </div>
</div>
<div class="layout-overlay" (click)="closeSidenav()"></div>
